import { useAudioPosition } from 'react-use-audio-player'
import { secondsToFullString, secondsToString } from '@mote/helpers'
import { Text, VisuallyHidden } from '@mote/ui'
import styled from '@xstyled/styled-components'
import { useMotePlayer } from '../contexts/motePlayer.context'

export const Durations = ({
  currentTime = undefined,
  totalTime = undefined,
  className = undefined,
  divider = 'space',
  fontSize = 14,
  fontWeight = 400,
  lineHeight = '100%',
  color = 'grey.d2',
  context = 'mote-player',
  variant = 'full',
  showPrefix = true,
  ...rest
}) => {
  const { position, duration } =
    context === 'mote-player' ? useMotePlayer() : useAudioPosition()
  const textProps = { fontSize, fontWeight, lineHeight, color, ...rest }

  const parsedTotalTime =
    totalTime === '{{ totalTime }}' || typeof totalTime === 'undefined'
      ? totalTime
      : Math.ceil(totalTime)

  const parsedDuration =
    parsedTotalTime === '{{ totalTime }}'
      ? {
          compact: parsedTotalTime,
          full: parsedTotalTime
        }
      : {
          compact: secondsToString(parsedTotalTime || Math.ceil(duration)),
          full: secondsToFullString(parsedTotalTime || Math.ceil(duration))
        }

  return (
    <DurationsContainer className={className} divider={divider}>
      {variant === 'compact-total' && (
        <Text tag='span' {...textProps} data-testid='total-duration'>
          <span aria-hidden={true}>{parsedDuration.compact}</span>
          <VisuallyHidden>
            {`Total duration: ${parsedDuration.full}`}
          </VisuallyHidden>
        </Text>
      )}
      {variant === 'full' && (
        <>
          <Text tag='span' {...textProps} data-testid='current-duration'>
            <span aria-hidden={true}>
              {secondsToString(Math.ceil(currentTime || position))}
            </span>
          </Text>
          <VisuallyHidden>
            {`Played: ${secondsToFullString(
              Math.ceil(currentTime || position)
            )}`}
          </VisuallyHidden>
          {divider !== 'space' && (
            <Text tag='span' {...textProps} aria-hidden={true}>
              {divider}
            </Text>
          )}
          <Text tag='span' {...textProps} data-testid='total-duration'>
            <span aria-hidden={true}>{parsedDuration.compact}</span>
            <VisuallyHidden>
              {`Duration: ${parsedDuration.full}`}
            </VisuallyHidden>
          </Text>
        </>
      )}
      {variant === 'compact-remaining' && (
        <Text tag='span' {...textProps} data-testid='remaining-duration'>
          <span aria-hidden={true}>
            {`${showPrefix ? '-' : ''}${secondsToString(
              Math.ceil(duration - position)
            )}`}
          </span>
          <VisuallyHidden>
            {`Remaining duration: ${showPrefix ? '-' : ''}${secondsToString(
              Math.ceil(duration - position)
            )}`}
          </VisuallyHidden>
        </Text>
      )}
    </DurationsContainer>
  )
}

const DurationsContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: ${({ divider }) =>
    divider === 'space' ? 'space-between' : 'initial'};
  gap: 4px;
`
